import { useEffect } from 'react';

import { blurActiveElement } from '@/utils';
import { PLATFORMS, PLATFORM_CAPTIONS } from '@/constants';

const platforms = Object.keys(PLATFORMS);

const SourceTargetSelect = ({
  source,
  target,
  disabled,
  onSourceChange,
  onTargetChange,
}) => {
  const targets = source
    ? platforms.filter(
        (platform) => !(source === PLATFORMS.apple && platform === source)
      )
    : [];

  // Whenever source changes reset target if:
  // 1. source is empty
  // 2. the current target is not available for the source
  useEffect(() => {
    if (!source || (target && !targets.includes(target))) {
      onTargetChange('');
    }
  }, [source]);

  return (
    <div className="row g-3">
      <div className="col-12 col-md-6">
        <div className="input-group w-100">
          <label htmlFor="sourceSelect" className="input-group-text shadow-sm">
            Source
          </label>

          <select
            id="sourceSelect"
            disabled={disabled}
            value={source || ''}
            className="form-select border shadow-sm"
            onChange={(e) => {
              blurActiveElement();
              onSourceChange(e.target.value || null);
            }}
          >
            <option value="">Choose...</option>

            {platforms.map((platform) => {
              return (
                <option key={platform} value={platform}>
                  {PLATFORM_CAPTIONS[platform]}
                </option>
              );
            })}
          </select>
        </div>
      </div>

      <div className="col-12 col-md-6">
        <div className="input-group w-100">
          <label
            htmlFor="targetSelect"
            className="input-group-text shadow-sm ps-3"
          >
            Target
          </label>

          <select
            id="targetSelect"
            disabled={disabled}
            value={target || ''}
            className="form-select border shadow-sm"
            onChange={(e) => {
              blurActiveElement();
              onTargetChange(e.target.value || null);
            }}
          >
            <option value="">Choose...</option>

            {targets.map((platform) => {
              return (
                <option key={platform} value={platform}>
                  {PLATFORM_CAPTIONS[platform]}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    </div>
  );
};

export default SourceTargetSelect;
